import { httpClient } from 'Shared/network';
import { QUERY_KEY } from '@constants';

export interface FAQResponse {
  data: {
    content: string;
    createdAt: string;
    faqUuid: string;
    isExposed: boolean;
    sortOrder: number;
    title: string;
  }[];
}

export const getFAQ = async (): Promise<FAQResponse> => {
  const { data } = await httpClient.get<FAQResponse>(QUERY_KEY.FAQ);
  return data;
};
